import { reduxKey } from '../reducers';
import { defaultStreamState } from '../constants';
export var getStreamIds = function (state) {
    return (state[reduxKey] && Object.keys(state[reduxKey])) || [];
};
export var getIsValidStream = function (state, streamId) { var _a; return !!((_a = state === null || state === void 0 ? void 0 : state[reduxKey]) === null || _a === void 0 ? void 0 : _a[streamId]); };
export var getStream = function (state, streamId) {
    return (state[reduxKey] && state[reduxKey][streamId]) || defaultStreamState;
};
export var getStreamType = function (state, streamId) {
    return getStream(state, streamId).streamType;
};
export var getStreamIdsByGroupId = function (state, groupId) {
    return Object.keys(state[reduxKey]).filter(function (streamId) { return getGroupId(state, streamId) === groupId; });
};
export var findItemInStreams = function (state, groupId, callback) {
    var streamIds = getStreamIdsByGroupId(state, groupId);
    var foundItem;
    streamIds.forEach(function (streamId) {
        if (!foundItem) {
            var items = getItems(state, streamId);
            foundItem = items.find(callback);
        }
    });
    return foundItem;
};
export var getGroupId = function (state, streamId) {
    return getStream(state, streamId).groupId;
};
export var getStreamParams = function (state, streamId) { return getStream(state, streamId).streamParams; };
export var getStreamParamsSafe = function (state, streamId) { return getStream(state, streamId).streamParams || {}; };
export var getStreamParam = function (state, streamId, paramType) {
    return getStreamParamsSafe(state, streamId)[paramType];
};
export var getItemsPerFetch = function (state, streamId) {
    return getStream(state, streamId).itemsPerFetch;
};
export var getItems = function (state, streamId) {
    return getStream(state, streamId).items || [];
};
export var getTotal = function (state, streamId) {
    return getStream(state, streamId).total || 0;
};
export var isInitialized = function (state, streamId) {
    return state[reduxKey] !== undefined && state[reduxKey][streamId] !== undefined;
};
export var isFetching = function (state, streamId) {
    return getStream(state, streamId).isFetching || false;
};
export var hasMore = function (state, streamId) {
    return getStream(state, streamId).hasMore || false;
};
export var getHasLess = function (state, streamId) {
    return getStream(state, streamId).hasLess || false;
};
export var getHasMoreInDirection = function (state, streamId, direction) {
    if (direction === void 0) { direction = 'next'; }
    switch (direction) {
        case 'prev':
            return getHasLess(state, streamId);
        case 'all':
            return hasMore(state, streamId) || getHasLess(state, streamId);
        case 'next':
        default:
            return hasMore(state, streamId);
    }
};
export var getErrorMsg = function (state, streamId) {
    return getStream(state, streamId).errorMsg;
};
export var getTotalItemsCount = function (state) {
    var count = 0;
    var streamIds = getStreamIds(state);
    if (streamIds.length) {
        for (var _i = 0, streamIds_1 = streamIds; _i < streamIds_1.length; _i++) {
            var streamId = streamIds_1[_i];
            count += getItems(state, streamId).length;
        }
    }
    return count;
};
export var getFetchFailures = function (state, streamId) {
    return getStream(state, streamId).fetchFailuresConsecutive || 0;
};
export var canStreamAutoFetch = function (state, streamId) {
    return (!isFetching(state, streamId) &&
        !getErrorMsg(state, streamId) &&
        hasMore(state, streamId) &&
        getItems(state, streamId).length === 0);
};
//# sourceMappingURL=selectors.js.map